module.exports = __webpack_public_path__ + "static/media/LB100.eafe38d4.png";